import React, { useState } from "react";
import RegisterButton from "../buttons/RegisterButton";
import GitHubSvg from "../icons/GitHubSvg";

const RegisterCallToAction: React.FC = (props) => {
  return (
    <div className="p-4 my-8 bg-black rounded-lg dark:bg-white">
      <p className="mb-2 text-white dark:text-black">
        <span className="font-bold text-primary">Codealo</span> es la mejor
        comunidad LATAM en español.
      </p>
      <p className="mb-4 text-sm text-gray-200 dark:text-gray-700">
        Únete y seamos la comunidad de developers hispanohablantes más grande
        del{" "}
        <span role="img" aria-label="earth">
          🌎
        </span>
      </p>
      <div>
        <RegisterButton className="flex flex-row items-center justify-center w-full py-2 font-semibold bg-white rounded dark:bg-black">
          <GitHubSvg className="w-4 h-4 mr-2 text-black fill-current dark:text-white" />{" "}
          Ingresar con GitHub
        </RegisterButton>
      </div>
    </div>
  );
};

export default RegisterCallToAction;
